import SVG from '../../../images/svg/SVG.js';
import React from 'react';

const LeadDataSectionHeading = ({ className, icon, back, onBackClick, children, add, onAddClick }) => {
  return (
    <div className={`section-heading ${className}`}>
      {icon && <SVG icon={icon} className={'section-icon'} />}
      <div className={'label'}>
        {back && (
          <>
            <span className={'back'} onClick={onBackClick}>
              {back}
            </span>
            <span className={'slash'}>/</span>
            {back && (
              <div className={'back-button'} onClick={onBackClick}>
                Back
              </div>
            )}
          </>
        )}
        <span>{children}</span>
      </div>
      {add && (
        <div className={'add'} onClick={onAddClick} data-title={add}>
          <SVG icon={'Add'} />
        </div>
      )}
    </div>
  );
};

export default LeadDataSectionHeading;
